import {Injectable} from '@angular/core';
import {CommonService} from "../services/common.service";
import {Observable} from "rxjs";
import {v1URL} from "../constants/urls.constants";
import {FetchProfileModel} from "../models/fetch-profile.model";
import {UpdatePasswordModel} from "../models/update-password.model";
import {GenerateUsername} from "../models/generate-username";
import {VerifyUsername} from "../models/verify-username";
import {EditProfileModel} from "../models/edit-profile.model";
import {QuestionResponse} from "../../../models/question-response";
import {
  SaveAnswersModel
} from "../../page-modules/participants-list/models/save-answers.model";
import {
  FetchClientStatusFilterModel
} from "../../page-modules/client-details/models/fetch-client-status-filter.model";
import {GenerateOtpModel} from "../../authentication/models/generate-otp.model";
import {VerifyOtpModel} from "../../authentication/models/verify-otp.model";
import {HttpBackend, HttpClient, HttpHeaders} from "@angular/common/http";
import {
  FetchUserStatusFilterModel
} from "../models/fetch-user-status-filter.model";
import {CdnDeleteUploadedImageModel} from '../models/cdn-image.model';

@Injectable({
  providedIn: 'root',
})

export class SharedService {
  private httpClient: HttpClient;

  constructor(private commonServices: CommonService, private httpBackend: HttpBackend) {
    this.httpClient = new HttpClient(httpBackend);
  }

  editProfile(payload): Observable<EditProfileModel["response"]> {
    const urlConfig = v1URL.user.profile.edit
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  fetchProfile(payload?: FetchProfileModel['request']): Observable<FetchProfileModel['response']> {
    const urlConfig = v1URL.user.profile.fetch;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload), payload);
  }

  updatePassword(payload: UpdatePasswordModel['request']): Observable<UpdatePasswordModel['response']> {
    const urlConfig = v1URL.user.password.update
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  generateUsername(payload: GenerateUsername['request']): Observable<GenerateUsername['response']> {
    const urlConfig = v1URL.username.generate
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  verifyUsername(payload: VerifyUsername['request']): Observable<VerifyUsername['response']> {
    const urlConfig = v1URL.username.verify
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  saveAnswers(payload?: { responses?: QuestionResponse[] }): Observable<SaveAnswersModel["response"]> {
    const urlConfig = v1URL.user['ob-questions']['save-responses']
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  generateOtp(payload: GenerateOtpModel['request']): Observable<GenerateOtpModel['response']> {
    const urlConfig = v1URL.otp.generate
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  verifyOtp(payload: VerifyOtpModel['request']): Observable<VerifyOtpModel['response']> {
    const urlConfig = v1URL.otp.verify
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  genderFilter(): Observable<FetchClientStatusFilterModel['response']> {
    const urlConfig = v1URL.filters.gender
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchUserStatusFilter(): Observable<FetchUserStatusFilterModel['response']> {
    const urlConfig = v1URL.filters['user-status']
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  getSignedUrlForImageUpload(params: {
    fileName: string,
    contentType: string
  }): Observable<any> {
    const urlConfig = v1URL.imageUpload.getSignedUrl
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(params))
  }

  uploadImageToCdn(signedUrl: string, formData: any, contentType: string): Observable<any> {
    const header = new HttpHeaders().set('Content-Type', contentType)
    return this.httpClient.put(signedUrl, formData, {
      headers: header
    })
  }

  deleteUploadedImage(payload: CdnDeleteUploadedImageModel['request']): Observable<CdnDeleteUploadedImageModel['response']> {
    const urlConfig = v1URL.imageUpload.deleteUploadedImage
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload)
  }

  avatarFilter(): Observable<any> {
    const urlConfig = v1URL.avatars
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url)
  }

  deleteUser(payload: CdnDeleteUploadedImageModel['request']): Observable<CdnDeleteUploadedImageModel['response']> {
    const urlConfig = v1URL.user.profile.delete
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload))
  }

  updateAdultDetails(payload): Observable<any> {
    const urlConfig = v1URL.user.profile.updateAdultDetails;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url, payload);
  }

  fetchRelationsFilter(): Observable<any> {
    const urlConfig = v1URL.filters.relations;
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url);
  }

  fetchObQuestions(payload): Observable<any> {
    const urlConfig = v1URL.user['ob-questions']['ob-questions'];
    return this.commonServices.callAPI(urlConfig.method, urlConfig.url(payload));
  }
}
